import Decimal from "decimal.js"

export default function Details({ dateOfPurchase, dateofSelling }) {
    const totalSum = Decimal(dateofSelling) - Decimal(dateOfPurchase);
    return (
        <div className="calculation-details">
            {totalSum > 0 ? (
                <>
                    <p className="calculation-details">{`${dateofSelling} - ${dateOfPurchase} = ${totalSum}`}</p>
                    <p className="calculation-details">{`10% * ${totalSum} = ${(10 / 100) * totalSum}`}</p>
                </>
            ) : (
                <p className="calculation-details">{`${dateofSelling} - ${dateOfPurchase} = ${totalSum}`}</p>
            )}
        </div>
    )
}

